import React from 'react';
import styled from 'styled-components';
import Testimonials from '../components/Testimonials';

const PageWrapper = styled.div`
  padding-top: 100px; 
  min-height: 100vh;
  background-color: #f8fafc;
`;

const TestimonialsPage = () => {
  return (
    <PageWrapper>
      <Testimonials />
    </PageWrapper>
  );
};

export default TestimonialsPage;
